import { render, staticRenderFns } from "./NestedSelectParent.vue?vue&type=template&id=848d3460"
import script from "./NestedSelectParent.vue?vue&type=script&lang=js"
export * from "./NestedSelectParent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports